module.exports = __webpack_public_path__ + "static/media/sales.132b0f2b.png";